import _ from 'lodash'
import cookie from 'js-cookie'
import axios from 'axios'
import AbortController from 'abort-controller'
import router from '../router'
import i18n from '../plugins/i18n'
import config from '../config'

const axiosInstance = axios.create({
  baseURL: config.api_url,
  json: true,
  withCredentials: true
})

// delay beetween requests
let currentTime = Date.now()
const delayRateLimit = (rateLimit = 80) => {
  return new Promise(resolve => {
    const rateMs = Math.ceil(1000 / rateLimit)
    const interval = Date.now() - currentTime
    const delay = interval > rateMs ? 0 : rateMs - interval
    setTimeout(resolve, delay)
    currentTime = Date.now() + delay
  })
}

const abortControllers = {}

/*
request
*/
axiosInstance.interceptors.request.use((config) => {
  const token = cookie.get('access_token')

  // regra de abortagem por abortid
  // em alguns casos, quando cliente possuem latencia de conexão muito alta, ao usar filtros do tipo keypress as requisições não chegam de forma sequencial
  // esse script cancela a requisição anterior antes de iniciar uma nova com base no abortid
  const abortid = _.get(config, 'params.abortid')
  if (abortid) {
    config.params = _.omit(config.params, 'abortid')
    if (abortControllers[abortid]) {
      abortControllers[abortid].abort()
    }
    const controller = new AbortController()
    config.signal = controller.signal
    abortControllers[abortid] = controller
  }

  if (i18n.locale) {
    config.headers['Accept-Language'] = i18n.locale
  }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return delayRateLimit().then(() => {
    return config
  })
}, (err) => {
  return Promise.reject(err)
})

/*
response
*/
axiosInstance.interceptors.response.use((response) => {
  return response
}, (err) => {
  const config = err.config || {}

  if (config.skipErrorRedirect) {
    return Promise.reject(err)
  }

  console.log(err.response)

  if (err.response && err.response.status === 401) {
    router.push('/auth')
  }

  if (err.response && err.response.status === 402) {
    router.push('/billing')
  }

  return Promise.reject(err)
})

export default axiosInstance



// WEBPACK FOOTER //
// ./src/utils/AxiosInstance.js